export default (theme) => ({
  associationHeaderContainer: {
    padding: "8px 30px",
    backgroundColor: "#f3f3f3",
  },
  associationHeader: {
    fontSize: 13,
    fontWeight: 600,
  },
  tableContainer: {
    padding: "18px",
  },
  menuItem: {
    textDecoration: "none",
  },
});
